import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { DialogButton } from '@snapon/design-system-angular';
import { AppInfoService } from 'core/app-info/app-info.service';
import { NotificationService } from 'core/notification/notification.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { DeviceDetectorService } from 'ngx-device-detector';
import { B2BUser } from '../entities/b2b-user-info';
import { B2bUserCartComponent } from '../b2b-user-cart/b2b-user-cart.component';
import { B2bUserCartService } from '../services/b2b-user-cart.service';

@Component({
  selector: 'app-b2b-edit-cart',
  templateUrl: './b2b-edit-cart.component.html',
  styleUrls: ['./b2b-edit-cart.component.scss'],
  standalone: false
})
export class B2bEditCartComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(B2bUserCartComponent) cartComponent: B2bUserCartComponent;

  subs = new Subscription();
  customerId: string;
  userId: number;
  bpNumber: string;
  countryCodeId: number;
  user: B2BUser;
  appStrings;
  breadcrumbs = [];
  isMobile: boolean;
  deleteCartDialogOpen$ = new EventEmitter<boolean>();
  deleteDialogButtons: DialogButton[] = [];
  loading = false;


  constructor(
    private route: ActivatedRoute,
    public appInfoService: AppInfoService,
    private location: Location,
    private deviceService: DeviceDetectorService,
    private b2bUserCartService: B2bUserCartService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.appStrings = this.appInfoService.appStrings;
    this.isMobile = this.deviceService.isMobile();
    this.initializeDialogButtons();

    // Get route parameters and state
    this.subs.add(this.route.params.subscribe(params => {
      this.customerId = params['customerId'];

      const state = this.location.getState() as any;
      this.userId = Number(state?.userId);
      this.bpNumber = state?.shipToBPs;
      this.countryCodeId = state?.countryCodeId;
      const userData = state?.userData;

      this.user = {
        UserId: this.userId,
        ShipToBPs: this.bpNumber,
        itemsInCart: 1, // Set to 1 to trigger loading
        UserName: userData?.UserName || '',
        FirstName: userData?.FirstName || '',
        LastName: userData?.LastName || '',
        Email: userData?.Email || ''
      } as B2BUser;
      this.breadcrumbs = this.getBreadcrumbs();
    }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngAfterViewInit(): void {
    if (this.cartComponent) {
      this.subs.add(
        this.cartComponent.cartItemsLoaded.subscribe((data) => {
          this.onCartItemsLoaded(data);
        })
      );
      this.cartComponent.loadCartItems();
    }
  }

  onCartItemsLoaded(data: { userIndex: number, cartItems: any[] }): void {
    if (this.user) {
      // Exclude empty row at beginning if in edit mode
      const validItems = data.cartItems.filter(item => item.ModelNumber);
      this.user.itemsInCart = validItems.length;
    }
  }

  goBack() {
    this.location.back();
  }

  getBreadcrumbs(): any[] {
    return [
      {
        label: this.appStrings.contacts_accountDetails,
        icon: this.isMobile ? 'arrow_back' : null,
        url: ['/accounts', this.customerId, { tab: 'b2b-users' }]
      },
      {
        label: this.appStrings.menu_Users + ' ' + this.appStrings.button_editCart
      }
    ];
  }

  private initializeDialogButtons(): void {
    this.deleteDialogButtons = [
      {
        type: 'secondary',
        label: 'Delete B2B Cart',
        onclick: () => this.confirmDeleteCart()
      },
      {
        type: 'primary',
        label: 'Keep B2B Cart',
        onclick: () => { }
      }
    ];
  }

  showDeleteCartDialog(): void {
    this.deleteCartDialogOpen$.emit(true);
  }

  confirmDeleteCart(): void {
    if (this.user) {
      this.loading = true;
      this.subs.add(
        this.b2bUserCartService.deleteCart(this.user.UserId.toString()).subscribe({
          next: () => {
            this.notificationService.showNotification(this.appStrings.b2bCart_deleteCartSuccess, NotificationType.Success);
            this.cartComponent?.reloadItems();
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          }
        })
      );
    }
  }

  addItem(): void {
    if (this.cartComponent) {
      this.cartComponent.addItem();
    }
  }
}
